import { render, staticRenderFns } from "./chineseDrugAdvice.vue?vue&type=template&id=49a0c684&scoped=true"
import script from "./chineseDrugAdvice.vue?vue&type=script&lang=js"
export * from "./chineseDrugAdvice.vue?vue&type=script&lang=js"
import style0 from "./chineseDrugAdvice.vue?vue&type=style&index=0&id=49a0c684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a0c684",
  null
  
)

export default component.exports